import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import utils from '../../utils';
import adminServices from '../../services/AdminServices';
import FormError from '../feedback/FormError';
import moment from 'moment';

function UserForm({ action, activeUser, role, onSuccess }) {
    const [isAdmin, setIsAdmin] = useState(false);
    const [isVerified, setIsVerified] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [fullName, setFullName] = useState('')
    const [passwordType, setPasswordType] = useState("password")
    const [image, setImage] = useState(null);

    useEffect(() => {
        setError()
        if (activeUser?.user && action === 1) {
            if (activeUser?.user?.email) {
                setEmail(activeUser?.user?.email)
            }
            if (activeUser?.user?.full_name) {
                setFullName(activeUser?.user?.full_name)
            } else {
                setFullName('')
            }
            if (activeUser?.user?.is_admin) {
                setIsAdmin(true)
            } else {
                setIsAdmin(false)
            }
            if (activeUser?.user?.is_verified) {
                setIsVerified(true)
            } else {
                setIsVerified(false)
            }
        }
        if (action === 0) {
            clearInput()
        }
    }, [action, activeUser])

    useEffect(() => { }, [error])
    useEffect(() => { }, [isAdmin])

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && !file.type.startsWith('image/')) {
            toast.error('Please select a valid image file.');
            e.target.value = '';
            return;
        }
        setImage(file);
    };

    function togglePassword() {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    function submitHandler(e) {
        // const closeBtn = document.getElementById("nurse-create-modal-close-btn")
        e.preventDefault()
        setError()
        setLoading(true)
        const submitToast = toast.loading(
            action === 0 ? `Adding ${role} user account` : `Updating ${role} user account`
        )
        const formData = new FormData()
        if (action === 0) {
            if (password.length < 8) {
                toast.error("Password length should be above 8 characters")
                setLoading(false)
                toast.dismiss(submitToast)
                return
            }
            formData.append("password", password)
        }

        formData.append("email", email)

        if (fullName) {
            formData.append("full_name", fullName)
        }
        formData.append("is_admin", isAdmin)
        formData.append("is_verified", isVerified)
        if (image) {
            formData.append("image", image)
        }
        if (action === 0) {
            formData.append("role", role)
            adminServices.addUser(formData).then(
                res => {
                    setLoading(false)
                    // closeBtn.click()
                    toast.success("User Added successfully", {
                        id: submitToast
                    })
                    onSuccess(
                        res.data
                    )
                },
                err => {
                    console.log(err);

                    setError(err)

                    setLoading(false)
                    toast.error(utils.errorMsg, {
                        id: submitToast
                    })
                    // setStage(1)
                }
            )
        } else {
            adminServices.updateUser(activeUser?.user?.id, formData).then(
                res => {
                    clearInput()
                    setLoading(false)
                    // closeBtn.click()
                    toast.success("User Updated successfully", {
                        id: submitToast
                    })
                    onSuccess(
                        res.data
                    )
                },
                err => {
                    setError(err)
                    setLoading(false)
                    toast.error(utils.errorMsg, {
                        id: submitToast
                    })
                }
            )
        }
    }

    function clearInput() {
        setEmail('')
        setFullName('')
        setPassword('')
        setIsAdmin(false)
        setImage(null)
    }

    return (
        <div className='space-y-3'>
            {action === 1 && activeUser && (
                <div className='flex flex-col gap-4 md:flex-row md:items-center'>
                    <div className='flex-grow-0 flex justify-center'>
                        {activeUser?.user?.image ? (
                            <div className="w-24 rounded-full">
                                <img
                                    className="rounded-full"
                                    src={activeUser?.user?.image}
                                    alt="profile"
                                />
                            </div>
                        ) : (
                            <div className='avatar placeholder'>
                                <div className="bg-neutral text-white rounded-full w-24">
                                    <span className="text-lg">{utils.makeProfileLetter(activeUser?.user)}</span>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="border flex-grow w-full border-border-light dark:border-border-dark bg-surface-light dark:bg-surface-dark p-3 shadow-sm transition-all hover:shadow-md rounded-xl">
                        <div className="space-y-2 text-sm">
                            <p className="font-bold">Overview</p>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <p>
                                    <span className="font-bold mr-2">Full Name:</span>
                                    {activeUser?.user?.full_name || '—'}
                                </p>
                                <p>
                                    <span className="font-bold mr-2">Email:</span>
                                    {activeUser?.user?.email || '—'}
                                </p>
                                <p>
                                    <span className="font-bold mr-2">Role:</span>
                                    {activeUser?.user?.role}
                                </p>
                                {activeUser.creation_time && (
                                    <p>
                                        <span className="font-bold mr-2">Joined:</span>
                                        {moment(activeUser?.creation_time).format("MMM Do YYYY")}

                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <form onSubmit={submitHandler}>
                {error && (<FormError error={error} />)}
                <div className="form-control mb-3">
                    <label className="label">
                        <span className="label-text">Email: *</span>
                    </label>
                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="input input-bordered w-full "
                    />
                </div>
                <div className="form-control mb-3">
                    <label className="label">
                        <span className="label-text">Full Name: *</span>
                    </label>
                    <input
                        type="text"
                        required
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                        className="input input-bordered w-full "
                    />
                </div>
                <div className={action === 0 ? "form-control mb-3" : "hidden"}>
                    <label className="label">
                        <span className="label-text">Password: *</span>
                    </label>
                    <input
                        type={passwordType}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="input input-bordered w-full "
                    />
                </div>
                <div className="form-control mb-3">
                    <label className="label">
                        <span className="label-text">
                            {action === 0 ? role === "Nurse" ? "Image *" : "Image (Optional)" : 'Image (Optional)'}
                        </span>
                    </label>
                    <input
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        className="file-input file-input-bordered w-full"
                        required={action === 0 && role === "Nurse"}
                    />
                </div>
                <div className="flex justify-between mb-3">
                    <div className='mb-3 flex gap-4 items-center'>
                        <label className="label">
                            <span className="label-text">Verified Account:</span>
                        </label>
                        <input
                            type="checkbox"
                            className="checkbox"
                            checked={isVerified}
                            onChange={(e) => setIsVerified(e.target.checked)} />
                    </div>
                    <div className={action === 1 ? "hidden" : "mb-3 flex gap-4 items-center"}>
                        <label className="label">
                            <span className="label-text">Show Password:</span>
                        </label>
                        <input
                            type="checkbox"
                            className="checkbox"
                            onClick={togglePassword} />
                    </div>
                </div>

                <div className='mt-6'>
                    <button
                        className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary disabled:opacity-75"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? 'Updating...' : (<>{action === 0 ? 'Create' : 'Update'}</>)}
                    </button>
                </div>
            </form>
        </div>
    )
}

export default UserForm